var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V16H496V176H16Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V176H496V336H16Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496V336H496V496H16Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 368.512C318.138 368.512 368.512 318.139 368.512 256C368.512 193.862 318.138 143.488 256 143.488C193.861 143.488 143.488 193.862 143.488 256C143.488 318.139 193.861 368.512 256 368.512Z",
    fill: "#2980B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 165.99L252.057 178.127L268.322 228.185H246.636L244.199 235.686H313.734L324.058 228.185H276.208L256 165.99Z",
    fill: "#FCDD09"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.249 222.624L308.906 183.18Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M280.249 222.624L308.906 183.18",
    stroke: "#FCDD09",
    strokeWidth: 4.19821
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/ET.561e054f31202c680168c3b3e33eb3c1.svg";
export { ForwardRef as ReactComponent };